module.exports = __webpack_public_path__ + "static/media/568.34fb3280.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/vehicleDetail/images/568.png
// module id = 777
// module chunks = 0